import { Table } from 'components/tables/Table';
import { FC, useMemo } from 'react';
import { companyLevelTableColumns } from './TableColumns';
import { useCompanyLevelFormContext } from './CompanyLevelFormContext';
import { RequestStatus } from 'types/RequestStatus';

const CompanyLevelTable: FC = () => {
	const { providerAccessLogs, accessEntriesStatus } =
		useCompanyLevelFormContext();

	const columns = useMemo(
		() => [
			companyLevelTableColumns.id(),
			companyLevelTableColumns.companyName(),
			companyLevelTableColumns.youniumAccountNumber(),
			companyLevelTableColumns.hubspotId(),
			companyLevelTableColumns.grantedAccess(),
			companyLevelTableColumns.lostAccess(),
			companyLevelTableColumns.lowestUserCount(),
			companyLevelTableColumns.highestUserCount(),
			companyLevelTableColumns.endDateUserCount(),
			companyLevelTableColumns.subscriptionType(),
			companyLevelTableColumns.realtime(),
			companyLevelTableColumns.youniumLink(),
		],
		[providerAccessLogs],
	);

	if (accessEntriesStatus === RequestStatus.UNLOADED) return null;

	return (
		<Table
			columns={columns}
			data={providerAccessLogs}
			requestStatus={accessEntriesStatus}
			withPagination
			paginationOptions={{
				initialPageSize: 10,
				showFromCount: 10,
			}}
		/>
	);
};

export default CompanyLevelTable;
